import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootPrintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_create_order_addresses_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { order_addresses: $frontendTypes.FootPrintApiManager.input_create_order_address[] }): Promise<{ order_addresses?: $frontendTypes.FootPrintApiManager.public_order_address[], errors?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_addresses)) {
      missingRequiredInParams.push('\'order_addresses\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

